var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#1c3f88}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6 8c0-3.3 2.7-6 6-6s6 2.7 6 6v1.8c0 1.4.4 2.8 1.1 4l.6.9c.4.6.6.9.6 1.2 0 .4-.2.8-.5.9-.3.2-.7.2-1.4.2H5.6c-.7 0-1.1 0-1.3-.1-.3-.2-.5-.5-.5-.9 0-.2.2-.6.6-1.2l.6-.9c.7-1.2 1.1-2.6 1.1-4V8zM14.4 18c.1 0 .2.1.1.1 0 .5-.3.9-.7 1.3-.5.4-1.1.6-1.8.6s-1.3-.2-1.8-.6c-.4-.3-.7-.8-.7-1.3 0-.1.1-.1.1-.1h4.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationDarkIcon);
export default __webpack_public_path__ + "static/media/notification-dark-icon.c90cb1e399d5c5411816500af0362b50.svg";
export { ForwardRef as ReactComponent };